import { html } from 'lit-html';
import { RrAreaLeftSide } from '../../../../core/views/pc/rr_item/rr_area_left_side';
import { RrAreaNormal } from '../../../../core/views/pc/rr_item/rr_area_normal';
import { KeywordJsEnv } from '../../models/keyword_js_env';

export const RrBodyKeywordNormal = (model: KeywordJsEnv) => html`
  ${RrAreaNormal(model.rrAreaProfileKeywordNormal, model.isLogin)}
`;

export const RrBodyKeywordLeftSide = (model: KeywordJsEnv) => html`
  ${RrAreaLeftSide(model.rrAreaProfileKeywordLeftSide, model.isLogin)}
`;
